import type { FaireProductEntity } from "../../entity_types/product";

export const p_mau69vnede: FaireProductEntity = {
  token: "p_mau69vnede",
  type: "product",
  name: "I ❤️ Soup Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/18fbff8e9154cec7cfb1dd81a72201eb61788b8e89fcbd5ab62929d1ca9a73cf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/569bfa8c82adb06bcbb0ea1776ed0696b7eb1471c96157760fcb1cff3f4a6be0.jpeg",
    "https://cdn.faire.com/fastly/4cd509b9b8d9ab3764298da2f0f814d09e95e3e6c7fb785dadcf841a9b828ce7.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/ce5cda1c75547d5f875a013b36e90d9349b57ac4bb739cc2db7745d9fb074db5.jpeg",
    "https://cdn.faire.com/fastly/bef15ed0d7c6fb8bf7d0a74a6847e87a08e195c5e289ed0acd14eb15ebcd317d.jpeg"
  ],
  priceDollars: 6.75,
  description: "There's something about food suspended in broth that makes you almost WANT to catch the flu. 😍 Skip the sniffles and score yourself some socks for the ultimate soup stan. 🍲 🤤\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:54.250Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
